import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';

export const getAdminMyHubPermission = (user: OhsUser | undefined) => {
  const adminModuleOptionsConfig = user?.configs?.admin2?.MODULE_OPTIONS;
  const communicationPermission =
    user?.tierNum === 5 || user?.configs?.correspondence?.PERMISSIONS?.view_roll || false;
  const trainingPermission = user?.configs?.training?.PERMISSIONS?.view || false;
  return !!(
    (adminModuleOptionsConfig?.allowActiveCorrespondenceExchangeView && communicationPermission) ||
    (adminModuleOptionsConfig?.allowActiveTrainingView && trainingPermission)
  );
};
const commonPermission = (user: OhsUser) => user?.configs?.admin2?.PERMISSIONS.view || false;
const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.Admin2}/${path}`,
  permission,
});

const OhsAdmin2RouteList = {
  [ModuleRoute.Settings]: createRoute('user-settings', commonPermission),
  [ModuleRoute.MyHub]: createRoute('my-hub', getAdminMyHubPermission),
  [ModuleRoute.ImportManager]: createRoute('import', commonPermission),
  [ModuleRoute.Xsi]: createRoute('xsi/:orgId', commonPermission),
  [ModuleRoute.Ada]: createRoute('ada/*', commonPermission),
  [ModuleRoute.UserActivity]: createRoute('useractivity', commonPermission),
};

export default OhsAdmin2RouteList;
